import { Link } from '@reach/router';
import React from 'react';
import { withColour } from './resourcesHelpers';

type Props = {
  /** Classes before the colour class, e.g. "Item ItemList01" */
  className: string;
  colorCSS?: string | null;
  name: string;
  imageSrc: string | null;
  imageAlt: string;
  /** Where Select goes */
  to: string;
  /** The Select button sits inside the picture's block, as on Awesome Stuff's first tile */
  bButtonInImage?: boolean;
};

/** A category, activity or group tile in the resource bank's tile lists */
const ResourceTile: React.FC<Props> = ({
  className,
  colorCSS,
  name,
  imageSrc,
  imageAlt,
  to,
  bButtonInImage = false,
}) => {
  const button = (
    <span className="BtnOne BtnSelect">
      <span>Select</span>
    </span>
  );

  return (
    <Link to={to} className={withColour(className, colorCSS)}>
      <span className="Border">
        <span className="Txt TxtList01">{name}</span>
        <span className="Img">
          {imageSrc && <img src={imageSrc} alt={imageAlt} />}
          {bButtonInImage && button}
        </span>
        {!bButtonInImage && button}
      </span>
    </Link>
  );
};

export default ResourceTile;
